import { ProfileColor } from "../../../dispatch/src/ProfileColor";
import { Checkbox, DataHeader, DataSource, DateRangeFilter, HorizontalSpacer, Label, Layout, Panel, Switch, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutOrderPayablesProfile extends Layout {
    checkboxDepartmentsExclude: Checkbox;
    checkboxPayeeIdsExclude: Checkbox;
    checkboxReasonCodeExclude: Checkbox;
    dataheaderOrderPayablesProfile: DataHeader;
    dateRangeFilter: DateRangeFilter;
    horizontalspacer1: HorizontalSpacer;
    horizontalspacer2: HorizontalSpacer;
    horizontalspacer3: HorizontalSpacer;
    labelPayeeTitle: Label;
    labelPaymentConfTitle: Label;
    labelRecordsTitle: Label;
    layoutProfileColor: ProfileColor;
    panelGeneral: Panel;
    panelPayee: Panel;
    panelPaymentConfiguration: Panel;
    panelRecords: Panel;
    panelSections: Panel;
    sourceOrderPayablesProfile: DataSource;
    switchHasInvoiceRecdDate: Switch;
    textboxCurrencyType: Textbox;
    textboxDepartment: Textbox;
    textboxDescr: Textbox;
    textboxFrozenPayables: Textbox;
    textboxGroupByDefault: Textbox;
    textboxId: Textbox;
    textboxInterfaceTransactionNum: Textbox;
    textboxPayeeIds: Textbox;
    textboxPayeeStatus: Textbox;
    textboxPayeeType: Textbox;
    textboxPaymentMethod: Textbox;
    textboxPaymentRecipient: Textbox;
    textboxReasonCode: Textbox;
}
